export const ogBase = {
  title: 'Extra | Build Your Credit With A Debit Card',
  // eslint-disable-next-line prettier/prettier
  description: 'Extra is the first debit card that builds credit and earns debit card points just like a credit card. No interest rates. No credit checks.',
  keywords: 'extra, debit, card, credit, credit building, rewards, points',
  url: process.env.BASE_URL || 'https://extra.app',
  image: 'https://s3.extra.app/site-assets/og-2022-1.jpg'
};
export function generateMetaHead({
  title,
  description,
  keywords,
  url,
  image
} = ogBase) {
  title = title || ogBase.title;
  description = description || ogBase.description;
  keywords = keywords || ogBase.keywords;
  url = url || ogBase.keywords;
  image = image || ogBase.image;
  return {
    title,
    htmlAttrs: {
      lang: 'en'
    },
    meta: [{
      charset: 'utf-8'
    }, {
      name: 'viewport',
      content: 'width=device-width, initial-scale=1'
    }, {
      hid: 'description',
      name: 'description',
      content: description
    }, {
      hid: 'keywords',
      name: 'keywords',
      content: keywords
    }, {
      hid: 'og:type',
      name: 'og:type',
      content: 'website'
    }, {
      hid: 'og:url',
      name: 'og:url',
      content: url
    }, {
      hid: 'og:title',
      name: 'og:title',
      content: title
    }, {
      hid: 'og:description',
      name: 'og:description',
      content: description
    }, {
      hid: 'og:image',
      name: 'og:image',
      content: image
    }, {
      hid: 'twitter:card',
      name: 'twitter:card',
      content: 'summary_large_image'
    }, {
      hid: 'twitter:url',
      name: 'twitter:url',
      content: url
    }, {
      hid: 'twitter:title',
      name: 'twitter:title',
      content: title
    }, {
      hid: 'twitter:description',
      name: 'twitter:description',
      content: description
    }, {
      hid: 'twitter:image',
      name: 'twitter:image',
      content: image
    }]
  };
}